import { useEffect, useState } from 'react';
import { shouldSuppressUpdateBanner } from '../utils/embedContext';

const POLL_MS = 60_000;

/**
 * 非公開の本番画面だけ、サーバの version.json と起動中ビルドを比べる。
 * 違っても再読み込みはしない。取得失敗でも何もしない。
 */
export function useAppUpdate(pathname: string): boolean {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (import.meta.env.DEV) return;
    if (shouldSuppressUpdateBanner()) return;

    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = (await res.json()) as { buildId?: unknown };
        if (cancelled) return;
        if (typeof data.buildId === 'string' && data.buildId !== __APP_BUILD_ID__) {
          setUpdateAvailable(true);
        }
      } catch {
        // ネットワーク失敗では案内も再読み込みもしない
      }
    };

    void check();
    const timer = window.setInterval(() => {
      void check();
    }, POLL_MS);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') void check();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [pathname]);

  return updateAvailable;
}
